(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shady-welcome-popup"]) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    const teaser = root.querySelector('[data-welcome-open]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const key = 'sm-welcome-10-v1';
    let memory = null;
    let timer;
    let previousFocus;
    const read = () => { try { return JSON.parse(localStorage.getItem(key)) || memory; } catch { return memory; } };
    const write = value => { memory = value; try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
    const show = () => {
      clearTimeout(timer);
      if (dialog.open || document.querySelector('dialog[open], cart-drawer.active, .menu-drawer-container[open]')) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      teaser.hidden = true;
    };
    const dismiss = () => { if (dialog.open) dialog.close(); };
    const completed = !!root.querySelector('[data-welcome-success]');
    const error = !!root.querySelector('[data-welcome-errors]');
    let record = read();
    teaser.hidden = !!record?.subscribed;
    teaser.addEventListener('click', show);
    root.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', dismiss));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss(); } });
    dialog.addEventListener('close', () => {
      clearTimeout(timer);
      record = read();
      if (!record?.subscribed) write({dismissedUntil: Date.now() + 14 * 86400000});
      teaser.hidden = !!record?.subscribed;
      if (previousFocus?.isConnected && previousFocus !== document.body) previousFocus.focus();
    });
    if (completed && location.hash === '#SMWelcomeForm') {
      write({subscribed: true});
      show();
      return;
    }
    if (error && location.hash === '#SMWelcomeForm') {
      show();
      return;
    }
    if (root.dataset.designMode === 'true') return;
    if (record?.subscribed || record?.dismissedUntil > Date.now()) return;
    timer = setTimeout(() => {
      if (document.visibilityState === 'visible') show();
    }, Number(root.dataset.delay) || 8000);
    window.addEventListener('pagehide', () => clearTimeout(timer), {once: true});
  }
  const start = () => document.querySelectorAll('[data-welcome-root]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();
})();
